import { render, staticRenderFns } from "./DifferenceIcon.vue?vue&type=template&id=eb120006&"
import script from "./DifferenceIcon.vue?vue&type=script&lang=js&"
export * from "./DifferenceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports